import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { getSubtypeHeader } from '../../../utils/subTypeHeader';

export default function RetailForm({ shopType, formState, setFormState }) {
  const subtype = shopType;
  const headerText = getSubtypeHeader(subtype);

  const handleCheckboxChange = (key, value) => {
    setFormState(key, value);
  };

  return (
    <div className="form-section">
      <h3 className="section-title">{headerText}</h3>

      {/* Specific to Clothing & Apparel */}
      {subtype === 'RT_clothing' && (
        <>
          <div className="field">
            <label>Clothing Categories</label>
            <InputText
              value={formState[`clothingCategories_${subtype}`] || ''}
              onChange={(e) => setFormState(`clothingCategories_${subtype}`, e.target.value)}
              placeholder="e.g. Men, Women, Kids, Activewear"
            />
          </div>

          <div className="field">
            <label>Size Range</label>
            <InputText
              value={formState[`sizeRange_${subtype}`] || ''}
              onChange={(e) => setFormState(`sizeRange_${subtype}`, e.target.value)}
              placeholder="e.g. XS - XXL"
            />
          </div>

          <div className="field">
            <label>Fabric subtypes</label>
            <InputText
              value={formState[`fabricsubtypes_${subtype}`] || ''}
              onChange={(e) => setFormState(`fabricsubtypes_${subtype}`, e.target.value)}
              placeholder="e.g. Cotton, Wool, Leather"
            />
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`offersAlterations_${subtype}`}
                checked={formState[`offersAlterations_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`offersAlterations_${subtype}`, e.checked)}
              />
              <label htmlFor={`offersAlterations_${subtype}`} className="ml-2">Offers Alterations</label>
            </div>
          </div>
        </>
      )}

      {/* Specific to Electronics */}
      {subtype === 'RT_electronics' && (
        <>
          <div className="field">
            <label>Electronics Categories</label>
            <InputText
              value={formState[`electronicsCategories_${subtype}`] || ''}
              onChange={(e) => setFormState(`electronicsCategories_${subtype}`, e.target.value)}
              placeholder="e.g. Mobile Phones, Laptops, Home Appliances"
            />
          </div>

          <div className="field">
            <label>Product Brands</label>
            <InputText
              value={formState[`productBrands_${subtype}`] || ''}
              onChange={(e) => setFormState(`productBrands_${subtype}`, e.target.value)}
              placeholder="e.g. Apple, Samsung, Sony"
            />
          </div>

          <div className="field">
            <label>Warranty Period</label>
            <InputText
              value={formState[`warranty_${subtype}`] || ''}
              onChange={(e) => setFormState(`warranty_${subtype}`, e.target.value)}
              placeholder="e.g. 1 year, 2 years"
            />
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`offersInstallation_${subtype}`}
                checked={formState[`offersInstallation_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`offersInstallation_${subtype}`, e.checked)}
              />
              <label htmlFor={`offersInstallation_${subtype}`} className="ml-2">Offers Installation Services</label>
            </div>
          </div>
        </>
      )}

      {/* Specific to Grocery / Convenience Store */}
      {subtype === 'RT_grocery' && (
        <>
          <div className="field">
            <label>Store Categories</label>
            <InputText
              value={formState[`storeCategories_${subtype}`] || ''}
              onChange={(e) => setFormState(`storeCategories_${subtype}`, e.target.value)}
              placeholder="e.g. Fresh Produce, Snacks, Beverages"
            />
          </div>

          <div className="field">
            <label>Open 24/7?</label>
            <div className="flex align-items-center">
              <Checkbox
                inputId={`open247_${subtype}`}
                checked={formState[`open247_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`open247_${subtype}`, e.checked)}
              />
              <label htmlFor={`open247_${subtype}`} className="ml-2">Yes</label>
            </div>
          </div>

          <div className="field">
            <label>Specialty Products</label>
            <InputText
              value={formState[`specialtyProducts_${subtype}`] || ''}
              onChange={(e) => setFormState(`specialtyProducts_${subtype}`, e.target.value)}
              placeholder="e.g. Organic, Imported, Local"
            />
          </div>
        </>
      )}

      {/* Specific to Furniture / Home Goods */}
      {subtype === 'RT_furniture' && (
        <>
          <div className="field">
            <label>Furniture Categories</label>
            <InputText
              value={formState[`furnitureCategories_${subtype}`] || ''}
              onChange={(e) => setFormState(`furnitureCategories_${subtype}`, e.target.value)}
              placeholder="e.g. Sofas, Tables, Chairs"
            />
          </div>

          <div className="field">
            <label>Material subtypes</label>
            <InputText
              value={formState[`materialsubtypes_${subtype}`] || ''}
              onChange={(e) => setFormState(`materialsubtypes_${subtype}`, e.target.value)}
              placeholder="e.g. Wood, Leather, Metal"
            />
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`deliveryAvailable_${subtype}`}
                checked={formState[`deliveryAvailable_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`deliveryAvailable_${subtype}`, e.checked)}
              />
              <label htmlFor={`deliveryAvailable_${subtype}`} className="ml-2">Delivery Available</label>
            </div>
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`assemblyAvailable_${subtype}`}
                checked={formState[`assemblyAvailable_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`assemblyAvailable_${subtype}`, e.checked)}
              />
              <label htmlFor={`assemblyAvailable_${subtype}`} className="ml-2">Assembly Available</label>
            </div>
          </div>
        </>
      )}

      {/* Specific to Specialty Shop */}
      {subtype === 'RT_specialty' && (
        <>
          <div className="field">
            <label>Specialty Categories</label>
            <InputText
              value={formState[`specialtyCategories_${subtype}`] || ''}
              onChange={(e) => setFormState(`specialtyCategories_${subtype}`, e.target.value)}
              placeholder="e.g. Pet Products, Toys, Collectibles"
            />
          </div>

          <div className="field">
            <label>Seasonal Products</label>
            <div className="flex align-items-center">
              <Checkbox
                inputId={`seasonalProducts_${subtype}`}
                checked={formState[`seasonalProducts_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`seasonalProducts_${subtype}`, e.checked)}
              />
              <label htmlFor={`seasonalProducts_${subtype}`} className="ml-2">Yes</label>
            </div>
          </div>

          <div className="field">
            <label>Product Origin</label>
            <InputText
              value={formState[`productOrigin_${subtype}`] || ''}
              onChange={(e) => setFormState(`productOrigin_${subtype}`, e.target.value)}
              placeholder="e.g. Imported, Local"
            />
          </div>
        </>
      )}

      {/* Shared options for Retail */}
      <div className="field">
        <div className="flex align-items-center">
          <Checkbox
            inputId={`offersDelivery_${subtype}`}
            checked={formState[`offersDelivery_${subtype}`] || false}
            onChange={(e) => handleCheckboxChange(`offersDelivery_${subtype}`, e.checked)}
          />
          <label htmlFor={`offersDelivery_${subtype}`} className="ml-2">Offers Delivery</label>
        </div>
      </div>

      <div className="field">
        <div className="flex align-items-center">
          <Checkbox
            inputId={`inStorePickup_${subtype}`}
            checked={formState[`inStorePickup_${subtype}`] || false}
            onChange={(e) => handleCheckboxChange(`inStorePickup_${subtype}`, e.checked)}
          />
          <label htmlFor={`inStorePickup_${subtype}`} className="ml-2">In-Store Pickup Available</label>
        </div>
      </div>
    </div>
  );
}